import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-8 flex-1 p-4 pt-0" }
const _hoisted_2 = { class: "flex flex-row w-full items-center" }
const _hoisted_3 = { class: "w-2/12" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "w-10/12 md:w-5/6 flex flex-col space-y-2 ml-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = { class: "w-full grid grid-cols-3 gap-4" }
const _hoisted_8 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-8" }

import { computed, Ref, ref, watch } from "vue";
import { useMapStore } from "@/store/useMapStore";
import { useCountriesStore } from "@/store/useCountriesStore";
import { StatusCountry } from "@/interfaces/StatusCountry";
import BottomSheet from "@/components/Menus/BottomSheet.vue";
import TitleBig from "@/components/Titles/TitleBig.vue";
import TextMedium from "@/components/Texts/TextMedium.vue";
import SunIcon from "@/components/Icons/SunIcon.vue";
import GrayCaseForMenu from "@/components/Menus/GrayCaseForMenu.vue";
import UnvisitedIcon from "@/components/Icons/UnvisitedIcon.vue";
import VisitedIcon from "@/components/Icons/VisitedIcon.vue";
import ToVisitIcon from "@/components/Icons/ToVisitIcon.vue";
import LanguageIcon from "@/components/Icons/LanguageIcon.vue";
import TitleMedium from "@/components/Titles/TitleMedium.vue";
import PopulationIcon from "@/components/Icons/PopulationIcon.vue";
import CurrencyIcon from "@/components/Icons/CurrencyIcon.vue";
import ContinentIcon from "@/components/Icons/ContinentIcon.vue";
import ReligionIcon from "@/components/Icons/ReligionIcon.vue";
import IconAndTextCountryInformationMenu from "@/components/Menus/IconAndTextCountryInformationMenu.vue";
import TextSmall from "@/components/Texts/TextSmall.vue";
import GlobeIcon from "@/components/Icons/GlobeIcon.vue";
import FlagIcon from "@/components/Icons/FlagIcon.vue";
import CupHotIcon from "@/components/Icons/CupHotIcon.vue";
import TelephoneIcon from "@/components/Icons/TelephoneIcon.vue";
import PcDisplayIcon from "@/components/Icons/PcDisplayIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CountryInformationMenu',
  props: {
    selectedCountry: {},
    dialogId: {}
  },
  setup(__props: any) {

const props = __props;

const userStore = useMapStore();
const countriesStore = useCountriesStore();

const lastUpdate: Ref<Date> = ref(new Date(2023, 10, 18));
const formattedData = computed(() => {
  // Extraction du jour, du mois et de l'année
  const day = lastUpdate.value.getDate();
  const month = lastUpdate.value.toLocaleString("en", { month: "long" });
  const year = lastUpdate.value.getFullYear();

  return `${day} ${month} ${year}`;
});

const informationsCountryApi = ref(null);

const informationsCountryJson = computed(() => {
  if (props.selectedCountry) {
    return countriesStore.getCountryById(props.selectedCountry);
  } else {
    return null;
  }
});

const fetchData = async () => {
  try {
    const response = await fetch(
      `https://restcountries.com/v3.1/alpha/${props.selectedCountry}`
    );
    const data = await response.json();
    lastUpdate.value = new Date();
    return data[0];
  } catch (error) {
    lastUpdate.value = new Date(2023, 10, 18);
    return null;
  }
};

watch(
  () => props.selectedCountry,
  async () => {
    informationsCountryApi.value = await fetchData();
  },
  { immediate: true }
);

const informationsUser = computed(() => {
  if (props.selectedCountry) {
    return userStore.getCountryById(props.selectedCountry);
  } else {
    return null;
  }
});

const updateStatus = (status: StatusCountry) => {
  userStore.updateCountryStatusByCode(props.selectedCountry, status);
};

function formatPopulation(population) {
  if (population >= 1000000000) {
    return (population / 1000000000).toFixed(1) + "B";
  } else if (population >= 1000000) {
    return (population / 1000000).toFixed(1) + "M";
  } else if (population >= 1000) {
    return (population / 1000).toFixed(1) + "K";
  } else {
    return population.toString();
  }
}

const realCountry = computed(() => {
  return countriesStore.getCountryById(
    informationsCountryJson.value.realCountry
  ).name;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BottomSheet, {
    "dialog-id": props.dialogId,
    "all-draggable": false,
    "out-side-closable": true,
    class: "z-50"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "w-full h-auto",
              src: informationsCountryJson.value.flag,
              alt: 
              informationsCountryApi.value !== null
                ? informationsCountryApi.value.name.common
                : informationsCountryJson.value.name
            
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(TitleBig, {
              text: 
              informationsCountryApi.value !== null
                ? informationsCountryApi.value.name.common
                : informationsCountryJson.value.name
            
            }, null, 8, ["text"]),
            _hoisted_6,
            _createVNode(TextMedium, {
              text: 
              informationsCountryApi.value !== null
                ? informationsCountryApi.value.capital[0]
                : informationsCountryJson.value.capital
            
            }, null, 8, ["text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(GrayCaseForMenu, {
            status: _unref(StatusCountry).Unvisited,
            "country-code": props.selectedCountry,
            "with-text": true
          }, null, 8, ["status", "country-code"]),
          _createVNode(GrayCaseForMenu, {
            status: _unref(StatusCountry).Visited,
            "country-code": props.selectedCountry,
            "with-text": true
          }, null, 8, ["status", "country-code"]),
          _createVNode(GrayCaseForMenu, {
            status: _unref(StatusCountry).ToVisit,
            "country-code": props.selectedCountry,
            "with-text": true
          }, null, 8, ["status", "country-code"])
        ]),
        _createVNode(TextSmall, {
          class: "w-full text-right",
          text: 'Last update : ' + formattedData.value
        }, null, 8, ["text"]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(IconAndTextCountryInformationMenu, {
            title: "Languages",
            text: 
            informationsCountryApi.value !== null
              ? Object.values(informationsCountryApi.value.languages).join(', ')
              : informationsCountryJson.value.languages.join(', ')
          
          }, {
            default: _withCtx(() => [
              _createVNode(LanguageIcon, { class: "w-full h-auto text-white" })
            ]),
            _: 1
          }, 8, ["text"]),
          _createVNode(IconAndTextCountryInformationMenu, {
            title: "Population",
            text: 
            informationsCountryApi.value !== null
              ? formatPopulation(informationsCountryApi.value.population.toString())
              : formatPopulation(informationsCountryJson.value.population.toString())
          
          }, {
            default: _withCtx(() => [
              _createVNode(PopulationIcon, { class: "w-full h-auto text-white" })
            ]),
            _: 1
          }, 8, ["text"]),
          _createVNode(IconAndTextCountryInformationMenu, {
            title: "Currency",
            text: 
            informationsCountryApi.value !== null
              ? `${Object.values(informationsCountryApi.value.currencies)[0].name} (${
                  Object.values(informationsCountryApi.value.currencies)[0].symbol
                })`
              : informationsCountryJson.value.currency.name
          
          }, {
            default: _withCtx(() => [
              _createVNode(CurrencyIcon, { class: "w-full h-auto text-white" })
            ]),
            _: 1
          }, 8, ["text"]),
          _createVNode(IconAndTextCountryInformationMenu, {
            title: "Continent",
            text: 
            informationsCountryApi.value !== null
              ? informationsCountryApi.value.continents.join(', ')
              : informationsCountryJson.value.continent
          
          }, {
            default: _withCtx(() => [
              _createVNode(ContinentIcon, { class: "w-full h-auto text-white" })
            ]),
            _: 1
          }, 8, ["text"]),
          _createVNode(IconAndTextCountryInformationMenu, {
            title: "Religion",
            text: informationsCountryJson.value.religion
          }, {
            default: _withCtx(() => [
              _createVNode(ReligionIcon, { class: "w-full h-auto text-white" })
            ]),
            _: 1
          }, 8, ["text"]),
          _createVNode(IconAndTextCountryInformationMenu, {
            title: "Area",
            text: 
            informationsCountryApi.value !== null
              ? `${informationsCountryApi.value.area} km²`
              : `${informationsCountryJson.value.area} km²`
          
          }, {
            default: _withCtx(() => [
              _createVNode(GlobeIcon, { class: "w-full h-auto text-white" })
            ]),
            _: 1
          }, 8, ["text"]),
          (
            informationsCountryJson.value !== null &&
            informationsCountryJson.value.independance
          )
            ? (_openBlock(), _createBlock(IconAndTextCountryInformationMenu, {
                key: 0,
                title: "Independent",
                text: informationsCountryJson.value.independance
              }, {
                default: _withCtx(() => [
                  _createVNode(FlagIcon, { class: "w-full h-auto text-white" })
                ]),
                _: 1
              }, 8, ["text"]))
            : _createCommentVNode("", true),
          (
            informationsCountryJson.value !== null &&
            informationsCountryJson.value.realCountry
          )
            ? (_openBlock(), _createBlock(IconAndTextCountryInformationMenu, {
                key: 1,
                title: "Country",
                text: realCountry.value
              }, {
                default: _withCtx(() => [
                  _createVNode(FlagIcon, { class: "w-full h-auto text-white" })
                ]),
                _: 1
              }, 8, ["text"]))
            : _createCommentVNode("", true),
          (
            informationsCountryJson.value !== null &&
            informationsCountryJson.value.national_dish
          )
            ? (_openBlock(), _createBlock(IconAndTextCountryInformationMenu, {
                key: 2,
                title: "National Dish",
                text: informationsCountryJson.value.national_dish
              }, {
                default: _withCtx(() => [
                  _createVNode(CupHotIcon, { class: "w-full h-auto text-white" })
                ]),
                _: 1
              }, 8, ["text"]))
            : _createCommentVNode("", true),
          (
            informationsCountryJson.value !== null &&
            informationsCountryJson.value.dialling_code
          )
            ? (_openBlock(), _createBlock(IconAndTextCountryInformationMenu, {
                key: 3,
                title: "Dialling code",
                text: informationsCountryJson.value.dialling_code
              }, {
                default: _withCtx(() => [
                  _createVNode(TelephoneIcon, { class: "w-full h-auto text-white" })
                ]),
                _: 1
              }, 8, ["text"]))
            : _createCommentVNode("", true),
          (
            informationsCountryJson.value !== null &&
            informationsCountryJson.value.domain_name
          )
            ? (_openBlock(), _createBlock(IconAndTextCountryInformationMenu, {
                key: 4,
                title: "Domain",
                text: informationsCountryJson.value.domain_name
              }, {
                default: _withCtx(() => [
                  _createVNode(PcDisplayIcon, { class: "w-full h-auto text-white" })
                ]),
                _: 1
              }, 8, ["text"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["dialog-id"]))
}
}

})